import { Command } from 'commands/Commands';

export class ChangeAddressDirections extends Command {
  type: string = 'ChangeAddressDirections';
  priority: number = 100;
}
